{
  "schema_version": 1,
  "source": "telugu_panchangam.personal.activity_rules.ACTIVITY_RULES",
  "consumed_fields": [
    "label",
    "avoid_karana",
    "prefer_lagna_class",
    "prefer_choghadiya",
    "skip_on_yoga",
    "skip_on_sankramana",
    "prefer_vara",
    "prefer_tithi_class",
    "avoid_tithi_class",
    "required_lagna_class",
    "allowed_maasams",
    "allowed_maasa_solar_pairs",
    "allowed_varas",
    "avoid_vara_paksha",
    "allowed_solar_classes",
    "allowed_nakshatras",
    "avoid_nakshatras",
    "prefer_nakshatras",
    "allowed_tithi_numbers",
    "prefer_tithi_numbers",
    "avoid_tithi_numbers",
    "manual_checks",
    "manual_prerequisites",
    "avoid_janma_nakshatra",
    "avoid_vara_tithi_names",
    "avoid_nitya_yogas",
    "allowed_lagnas",
    "prefer_lagnas",
    "caution_lagna_solar",
    "source_claim",
    "audit_claim",
    "heuristic_claim",
    "related_claims",
    "daytime_only",
    "forenoon_only",
    "allowed_pakshams",
    "require_homa_election",
    "allowed_solar_signs",
    "allowed_tithi_names",
    "skip_on_combust"
  ],
  "groups": [
    {
      "label": "General",
      "activities": [
        "any"
      ]
    },
    {
      "label": "Samskaras",
      "activities": [
        "wedding",
        "engagement",
        "naming",
        "annaprasana",
        "karnavedha",
        "mundana",
        "upanayana",
        "vidyarambha",
        "seemantha",
        "gruhapravesha"
      ]
    },
    {
      "label": "Acquisitions & finance",
      "activities": [
        "vehicle",
        "property",
        "house_purchase",
        "gold",
        "business_inventory_purchase",
        "purchase",
        "borrowing_money",
        "lending_money"
      ]
    },
    {
      "label": "Construction & ventures",
      "activities": [
        "bhumi_puja",
        "well_digging",
        "home_repair",
        "business",
        "job"
      ]
    },
    {
      "label": "Spiritual",
      "activities": [
        "yajna",
        "pilgrimage",
        "ceremony"
      ]
    },
    {
      "label": "Civil & medical",
      "activities": [
        "court",
        "surgery"
      ]
    },
    {
      "label": "Other",
      "activities": [
        "travel"
      ]
    }
  ],
  "rules": {
    "any": {
      "label": "Anything auspicious",
      "heuristic_claim": "muhurta.any.shared_scoring"
    },
    "wedding": {
      "label": "Wedding (Vivaha)",
      "avoid_karana": [
        "Vishti"
      ],
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_vara": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_maasams": [
        "Magha",
        "Phalguna",
        "Vaishakha",
        "Jyeshtha",
        "Kartika",
        "Margashira"
      ],
      "allowed_maasa_solar_pairs": [
        [
          "Pushya",
          "Makara"
        ],
        [
          "Chaitra",
          "Mesha"
        ]
      ],
      "allowed_varas": [
        "Adivaram",
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram",
        "Shanivaram"
      ],
      "allowed_nakshatras": [
        "Rohini",
        "Mrigashira",
        "Magha",
        "Uttara Phalguni",
        "Hasta",
        "Swati",
        "Anuradha",
        "Moola",
        "Uttara Ashadha",
        "Uttara Bhadrapada",
        "Revati"
      ],
      "manual_checks": [
        "Nakshatra Pada gate: reject Magha and Moola Pada 1 and Revati Pada 4. Pada is not computed across every surface, so the automated profile admits the star only subject to this mandatory check.",
        "Yoga vocabulary: Raman also rejects a named Mrityu Yoga that is not one of the engine’s 27 Nitya Yogas; verify the applicable lineage definition manually.",
        "Election chart: keep the 7th house unoccupied; Mangala out of the 8th; Shukra out of the 6th; Lagna free from malefics and not hemmed between them; and Chandra unassociated with another Graha.",
        "Fortification: consider Guru, Budha or Shukra in Lagna and malefics in the 3rd or 11th, or one of the source’s named marriage-election Yogas.",
        "Couple-specific prerequisites: complete horoscope compatibility review, Tarabala, Chandrabala and Panchaka review for both partners; an election cannot substitute for consent or relationship judgment.",
        "Lineage warning: current Drik Panchang Hyderabad dates admit some Tuesdays and Tithis Raman rejects. This profile follows Raman’s named method rather than silently blending published practices."
      ],
      "manual_prerequisites": true,
      "avoid_nitya_yogas": [
        "Vyatipata",
        "Dhruva",
        "Ganda",
        "Vajra",
        "Shoola",
        "Vishkambha",
        "Atiganda",
        "Vyaghata",
        "Parigha"
      ],
      "allowed_lagnas": [
        "Mithuna",
        "Kanya",
        "Tula",
        "Vrishabha",
        "Karka",
        "Simha",
        "Dhanu",
        "Kumbha"
      ],
      "prefer_lagnas": [
        "Mithuna",
        "Kanya",
        "Tula"
      ],
      "source_claim": "muhurta.wedding",
      "related_claims": [
        "muhurta.wedding.drkpanchang_divergence"
      ],
      "allowed_tithi_names": [
        "Shukla Pratipat",
        "Shukla Dwitiya",
        "Shukla Tritiya",
        "Shukla Panchami",
        "Shukla Saptami",
        "Shukla Dashami",
        "Shukla Ekadashi",
        "Shukla Trayodashi",
        "Krishna Pratipat",
        "Krishna Dwitiya",
        "Krishna Tritiya",
        "Krishna Panchami",
        "Krishna Saptami",
        "Krishna Dashami"
      ],
      "skip_on_combust": [
        "Guru",
        "Shukra"
      ]
    },
    "engagement": {
      "label": "Mutual engagement (Kanya-Varavarana)",
      "allowed_nakshatras": [
        "Rohini",
        "Krittika",
        "Purva Phalguni",
        "Purva Ashadha",
        "Purva Bhadrapada",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Uttara Bhadrapada"
      ],
      "manual_checks": [
        "Verse 11 additionally requires a Shubha day, Tithi and Lagna for Varavarana but does not enumerate them in this passage; the officiating practitioner must establish those three conditions.",
        "Scope: automation uses the intersection of the Kanyavarana and Varavarana star lists for a mutual engagement. A one-sided bride- or groom-selection rite may use its own broader verse-specific list.",
        "Complete consent, family and couple-specific compatibility review; this election cannot assess the relationship or promise a marriage outcome."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.kanya_varavarana"
    },
    "naming": {
      "label": "Naming (Namakaranam)",
      "prefer_lagna_class": "Sthira",
      "prefer_choghadiya": [
        "Shubh",
        1
      ],
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Nanda",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Anuradha",
        "Punarvasu",
        "Magha",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Uttara Bhadrapada",
        "Shatabhisha",
        "Swati",
        "Dhanishtha",
        "Shravana",
        "Rohini",
        "Ashwini",
        "Mrigashira",
        "Revati",
        "Hasta",
        "Pushya"
      ],
      "avoid_tithi_numbers": [
        4,
        6,
        8,
        9,
        12,
        14,
        15
      ],
      "manual_checks": [
        "Prefer the 10th, 12th or 16th day after birth; otherwise elect an auspicious day.",
        "Election chart: strengthen Lagna and leave the 8th house unoccupied.",
        "A common Lagna is acceptable only when occupied by benefics.",
        "Prefer Guru in a Kendra or Trikona with a malefic in the 11th.",
        "Alternative chart: benefic-sign Lagna, malefic in the 3rd, Shukra in the 12th and Chandra dignified.",
        "Choose a name appropriate to the ruling Nakshatra."
      ],
      "source_claim": "muhurta.namakarana"
    },
    "annaprasana": {
      "label": "Annaprasana (First feeding)",
      "prefer_choghadiya": [
        "Shubh",
        1
      ],
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Bhadra",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Mrigashira",
        "Punarvasu",
        "Dhanishtha",
        "Pushya",
        "Hasta",
        "Swati",
        "Anuradha",
        "Shravana",
        "Shatabhisha",
        "Uttara Phalguni",
        "Chitra"
      ],
      "avoid_tithi_numbers": [
        4,
        6,
        8,
        12,
        14,
        15
      ],
      "manual_checks": [
        "Perform first feeding in the child’s 6th, 8th, 9th or 12th month; the age-month is the most important criterion.",
        "Election chart: leave the 10th house unoccupied.",
        "Budha, Mangala and Shukra should not occupy the 7th, 8th and 9th houses respectively.",
        "Budha, Guru or Shukra in Lagna is highly commended; no malefic should occupy Lagna."
      ],
      "allowed_lagnas": [
        "Vrishabha",
        "Mithuna",
        "Karka",
        "Simha",
        "Kanya",
        "Tula",
        "Dhanu",
        "Makara",
        "Kumbha"
      ],
      "source_claim": "muhurta.annaprasana"
    },
    "karnavedha": {
      "label": "Karnavedha (Ear-piercing)",
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Bhadra",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "avoid_tithi_numbers": [
        4,
        6,
        8,
        12,
        14,
        15
      ],
      "manual_checks": [
        "Perform on the 12th or 16th day after birth, or in the child’s 6th, 7th or 8th month.",
        "Reject a day on which two Nakshatras or two Tithis rule during the ceremony period.",
        "Election chart: leave the 8th house unoccupied."
      ],
      "allowed_lagnas": [
        "Mesha",
        "Vrishabha",
        "Mithuna",
        "Karka",
        "Kanya",
        "Tula",
        "Dhanu",
        "Makara",
        "Meena"
      ],
      "source_claim": "muhurta.karnavedha",
      "daytime_only": true
    },
    "mundana": {
      "label": "Mundana / Chaula (First head-shave)",
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Nanda",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Punarvasu",
        "Mrigashira",
        "Dhanishtha",
        "Shravana",
        "Revati",
        "Pushya",
        "Chitra",
        "Ashwini",
        "Hasta",
        "Swati",
        "Rohini",
        "Shatabhisha",
        "Uttara Phalguni",
        "Uttara Bhadrapada",
        "Uttara Ashadha"
      ],
      "prefer_nakshatras": [
        "Punarvasu",
        "Mrigashira",
        "Dhanishtha",
        "Shravana",
        "Revati",
        "Pushya",
        "Chitra",
        "Ashwini",
        "Hasta"
      ],
      "allowed_tithi_numbers": [
        2,
        3,
        5,
        7,
        10,
        11,
        13
      ],
      "manual_checks": [
        "Perform in the child’s 3rd or 5th year, and not while the child’s mother is pregnant.",
        "Confirm the source’s stated Surya-in-Karkataka seasonal condition with the officiating astrologer.",
        "Other rising Rasis require a strong benefic in Lagna; Kumbha must still be rejected.",
        "Election chart: place benefics in the 4th, 5th, 7th, 9th, 10th and 11th; malefics in the 3rd, 6th and 11th.",
        "Leave the 8th house unoccupied and avoid Surya, Mangala or preferably any malefic in the 7th."
      ],
      "allowed_lagnas": [
        "Karka",
        "Kanya",
        "Mithuna",
        "Meena",
        "Tula",
        "Vrishabha",
        "Makara"
      ],
      "source_claim": "muhurta.mundana",
      "forenoon_only": true,
      "allowed_pakshams": [
        "Shukla"
      ],
      "skip_on_combust": [
        "Guru",
        "Shukra"
      ]
    },
    "upanayana": {
      "label": "Upanayana (Sacred thread)",
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Nanda",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_maasams": [
        "Magha",
        "Phalguna",
        "Chaitra",
        "Vaishakha"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Anuradha",
        "Hasta",
        "Chitra",
        "Swati",
        "Shravana",
        "Dhanishtha",
        "Shatabhisha",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Uttara Bhadrapada",
        "Revati",
        "Rohini",
        "Mrigashira",
        "Ashwini",
        "Punarvasu",
        "Pushya"
      ],
      "manual_checks": [
        "Perform in the 5th or 8th year; if delayed, apply the source’s age limits and exception rules.",
        "Reject Wednesday when Budha is combust.",
        "Chandra must not occupy the 6th, 8th or 12th from Lagna; avoid malefics in Kendras.",
        "Leave the 8th house unoccupied; fortify the 3rd and keep the 6th free of a benefic.",
        "Avoid Mangala and Shani in the 2nd, 5th or 12th.",
        "Avoid Chandra in Lagna except the source’s stated Karka-Lagna Guru conjunction exception.",
        "Review the named adverse and favorable election Yogas listed in the remainder of the passage."
      ],
      "allowed_lagnas": [
        "Mesha",
        "Vrishabha",
        "Mithuna",
        "Karka",
        "Kanya",
        "Tula",
        "Kumbha"
      ],
      "source_claim": "muhurta.upanayana",
      "forenoon_only": true,
      "allowed_solar_signs": [
        "Makara",
        "Kumbha",
        "Meena",
        "Mesha",
        "Vrishabha",
        "Mithuna"
      ],
      "allowed_tithi_names": [
        "Shukla Dwitiya",
        "Shukla Tritiya",
        "Shukla Panchami",
        "Shukla Saptami",
        "Shukla Dashami",
        "Shukla Trayodashi",
        "Krishna Pratipat",
        "Krishna Dwitiya",
        "Krishna Tritiya"
      ]
    },
    "vidyarambha": {
      "label": "Education start (Vidyarambha)",
      "prefer_choghadiya": [
        "Amrit",
        1
      ],
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "skip_on_sankramana": true,
      "prefer_tithi_class": "Nanda",
      "avoid_tithi_class": [
        "Jaya"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Punarvasu",
        "Ardra",
        "Hasta",
        "Chitra",
        "Swati",
        "Shravana",
        "Revati"
      ],
      "manual_checks": [
        "The source’s most propitious age marker is the 5th day of the 5th month of the child’s 5th year.",
        "Prefer the forenoon or noon for the ceremony.",
        "Election chart: leave the 8th house unoccupied.",
        "Budha, Shukra and Guru together in the 9th are stated to counteract adverse influences."
      ],
      "allowed_lagnas": [
        "Mesha",
        "Karka",
        "Tula",
        "Makara",
        "Mithuna",
        "Kanya",
        "Dhanu",
        "Meena"
      ],
      "source_claim": "muhurta.vidyarambha"
    },
    "seemantha": {
      "label": "Seemantha (Prenatal ceremony)",
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Rohini",
        "Mrigashira",
        "Punarvasu",
        "Pushya",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Hasta",
        "Shravana",
        "Revati"
      ],
      "manual_checks": [
        "Pregnancy timing: the cited passage ordains Seemantha for the first pregnancy, in the 5th or 7th month; if that schedule is missed, perform it before delivery under practitioner guidance. Muhurta Chintamani verse 8 instead specifies the 6th or 8th month; choose the family’s tradition with a qualified practitioner.",
        "Under unavoidable circumstances, Ashwini, Anuradha or Moola may be considered; the automated profile admits only the primary Nakshatra list.",
        "Pournami is admissible only when Chandra is dignified; the automated profile conservatively omits it pending chart judgment.",
        "Election chart: leave the 8th house vacant and do not place Chandra in the 8th.",
        "Personal star check: avoid the 3rd, 7th, 8th, 10th and 22nd Nakshatras counted from the mother’s birth Nakshatra.",
        "The source makes the pregnancy month primary and permits Guru or Shukra combustion to be ignored for this rite; no combustion gate is applied.",
        "Maternal comfort, clinician instructions and medical care always take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "allowed_lagnas": [
        "Mesha",
        "Vrishabha",
        "Mithuna",
        "Karka",
        "Kanya",
        "Tula",
        "Dhanu",
        "Makara",
        "Kumbha",
        "Meena"
      ],
      "source_claim": "muhurta.seemantha",
      "related_claims": [
        "muhurta.seemantha.chintamani_divergence"
      ],
      "allowed_tithi_names": [
        "Shukla Pratipat",
        "Shukla Dwitiya",
        "Shukla Tritiya",
        "Shukla Panchami",
        "Shukla Saptami",
        "Shukla Dashami",
        "Shukla Ekadashi",
        "Shukla Dwadashi",
        "Shukla Trayodashi",
        "Krishna Pratipat",
        "Krishna Dwitiya",
        "Krishna Tritiya",
        "Krishna Panchami",
        "Krishna Saptami",
        "Krishna Dashami",
        "Krishna Ekadashi",
        "Krishna Dwadashi",
        "Krishna Trayodashi"
      ]
    },
    "gruhapravesha": {
      "label": "Gruhapravesha (First entry into new home)",
      "prefer_lagna_class": "Sthira",
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Rohini",
        "Mrigashira",
        "Uttara Ashadha",
        "Chitra",
        "Uttara Bhadrapada",
        "Anuradha",
        "Revati"
      ],
      "manual_checks": [
        "Ritual scope: first ceremonial entry into a newly built home only; buying a completed house, moving rental, or re-entering after repairs are separate elections.",
        "Election chart: Guru, Shukra and Chandra should be strong; leave the 8th house vacant, place malefics in Upachayas and benefics in Kendras, and preferably use a Guru- or Shukra-owned rising Rasi.",
        "Lagna lineage: fixed Rasis are preferred and dual Rasis are ordinary. Raman permits a movable Rasi only with Vrishabha Navamsa; the automated profile conservatively omits that uncomputed exception.",
        "Personal and ritual checks: the owner’s Janma Rasi, Nakshatra or Lagna may strengthen the election; complete worship and Bhootabali before entry.",
        "Pregnancy safety: Raman advises avoiding entry after six months of the wife’s pregnancy. Maternal comfort, clinician instructions and medical care always take precedence over timing.",
        "Lineage warning: current Drik Panchang practice also admits some Saturdays and applies additional month filters; this profile follows Raman’s four weekdays rather than silently blending methodologies."
      ],
      "manual_prerequisites": true,
      "allowed_lagnas": [
        "Vrishabha",
        "Simha",
        "Vrischika",
        "Kumbha",
        "Mithuna",
        "Kanya",
        "Dhanu",
        "Meena"
      ],
      "source_claim": "muhurta.gruhapravesha",
      "related_claims": [
        "muhurta.gruhapravesha.drkpanchang_divergence"
      ],
      "allowed_solar_signs": [
        "Makara",
        "Kumbha",
        "Meena",
        "Mesha",
        "Vrishabha",
        "Mithuna"
      ],
      "allowed_tithi_names": [
        "Krishna Pratipat",
        "Shukla Dwitiya",
        "Shukla Tritiya",
        "Shukla Panchami",
        "Shukla Saptami",
        "Shukla Dashami",
        "Shukla Ekadashi",
        "Shukla Trayodashi"
      ]
    },
    "vehicle": {
      "label": "Vehicle purchase",
      "prefer_lagna_class": "Sthira",
      "prefer_choghadiya": [
        "Labh",
        1
      ],
      "prefer_vara": [
        "Shukravaram"
      ],
      "prefer_tithi_class": "Bhadra",
      "prefer_nakshatras": [
        "Shravana",
        "Dhanishtha",
        "Shatabhisha",
        "Punarvasu",
        "Swati"
      ],
      "source_claim": "muhurta.vehicle.acquisition"
    },
    "property": {
      "label": "Land purchase (for building)",
      "prefer_lagna_class": "Sthira",
      "prefer_vara": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shanivaram"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shanivaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Rohini",
        "Mrigashira",
        "Punarvasu",
        "Pushya",
        "Uttara Phalguni",
        "Hasta",
        "Swati",
        "Anuradha",
        "Uttara Ashadha",
        "Shravana",
        "Dhanishtha",
        "Shatabhisha",
        "Uttara Bhadrapada"
      ],
      "avoid_tithi_numbers": [
        4,
        9,
        14
      ],
      "manual_checks": [
        "Election chart: the weekday lord should preferably occupy Lagna.",
        "Election chart: Guru should occupy a Kendra or Trikona.",
        "Election chart: Mangala should occupy the 11th and not Lagna.",
        "Election chart: Lagna and 7th lords should be harmonious; avoid the 11th lord in the 12th."
      ],
      "source_claim": "muhurta.land_purchase.building"
    },
    "house_purchase": {
      "label": "Completed house purchase",
      "allowed_varas": [
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Mrigashira",
        "Ashlesha",
        "Magha",
        "Purva Phalguni",
        "Vishakha",
        "Moola",
        "Punarvasu",
        "Revati"
      ],
      "allowed_tithi_numbers": [
        1,
        6,
        11
      ],
      "manual_checks": [
        "Scope: use this profile for buying a completed new or old house; it is not land purchase, construction commencement, rental moving or Gruhapravesha.",
        "Election chart: keep malefics out of the 7th house.",
        "Election chart: do not place Mangala in Lagna.",
        "Legal title, structural inspection, financing and contract advice take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "prefer_lagnas": [
        "Vrishabha",
        "Mithuna",
        "Simha",
        "Tula",
        "Vrischika"
      ],
      "source_claim": "muhurta.house_purchase.completed",
      "related_claims": [
        "muhurta.purchase.general"
      ]
    },
    "gold": {
      "label": "Gold / Jewelry purchase",
      "prefer_lagna_class": "Sthira",
      "prefer_choghadiya": [
        "Labh",
        1
      ],
      "prefer_vara": [
        "Shukravaram",
        "Guruvaram"
      ],
      "prefer_tithi_class": "Bhadra",
      "manual_checks": [
        "Election chart: Surya and Chandra should be well situated and aspected; the cited passage leaves this as a chart judgment rather than a fixed weekday, Tithi, Nakshatra or Lagna list."
      ],
      "source_claim": "muhurta.gold_jewelry.purchase"
    },
    "business_inventory_purchase": {
      "label": "Trade inventory purchase",
      "prefer_vara": [
        "Guruvaram"
      ],
      "allowed_varas": [
        "Adivaram",
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram",
        "Shanivaram"
      ],
      "prefer_nakshatras": [
        "Pushya"
      ],
      "prefer_tithi_numbers": [
        10
      ],
      "manual_checks": [
        "Transaction role: buying stock, raw materials or goods for resale or business use; do not reuse this profile for selling inventory, launching a business or deploying capital.",
        "Saturday is described as passable, not preferred.",
        "Election chart: Budha, the 2nd lord and the 2nd house should be fortified.",
        "Election chart: avoid Budha afflicted by Mangala; Budha and Guru together in Lagna or in mutual aspect are described as highly favourable.",
        "Commercial need, stock quality, supplier terms, cash flow, tax and legal advice take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.trade_inventory.purchase",
      "related_claims": [
        "muhurta.purchase.general"
      ]
    },
    "purchase": {
      "label": "Purchase (general)",
      "prefer_choghadiya": [
        "Labh",
        1
      ],
      "prefer_nakshatras": [
        "Revati",
        "Shatabhisha",
        "Ashwini",
        "Swati",
        "Shravana",
        "Chitra"
      ],
      "manual_checks": [
        "Transaction role: verse 16 distinguishes purchase from sale Muhurtas; this profile evaluates the buyer’s side and must not be reused as a seller election.",
        "Marketplace check from verse 17: avoid Rikta Tithis, Tuesday and Kumbha Lagna; prefer Chandra and Shukra in Lagna, no malefics in the 8th or 12th, and benefics in the 2nd, 10th or 11th.",
        "Use the dedicated vehicle, building-land or gold profile when the object is known; their narrower rules take precedence over generic purchase."
      ],
      "source_claim": "muhurta.purchase.general"
    },
    "borrowing_money": {
      "label": "Borrowing money / taking a loan",
      "avoid_nakshatras": [
        "Krittika",
        "Moola",
        "Punarvasu",
        "Dhanishtha"
      ],
      "manual_checks": [
        "Transaction role: this is the borrower/debtor side only; do not reuse it for lending, receiving repayment or deploying capital.",
        "Personal-star gate: supply every borrower’s Janma Nakshatra so the source prohibition can be enforced; without it, review remains incomplete.",
        "Election chart: avoid Chandra conjoined with Mangala or Shani.",
        "Purpose-specific chart: for quick domestic or personal use, Chandra should favour Lagna; for business use, Chandra should favour Budha and the Lagna lord.",
        "Repayment capacity, total borrowing cost, lender terms, collateral risk and qualified financial or legal advice take precedence over timing."
      ],
      "manual_prerequisites": true,
      "avoid_janma_nakshatra": true,
      "source_claim": "muhurta.borrowing_money",
      "related_claims": [
        "muhurta.borrowing.chintamani_divergence"
      ]
    },
    "lending_money": {
      "label": "Lending money / giving a loan",
      "allowed_varas": [
        "Adivaram",
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shanivaram"
      ],
      "avoid_nakshatras": [
        "Krittika",
        "Magha",
        "Moola",
        "Shatabhisha",
        "Uttara Phalguni",
        "Punarvasu"
      ],
      "manual_checks": [
        "Transaction role: this is making a loan from the lender/creditor side; receiving repayment and borrowing money are separate elections.",
        "Personal-star gate: supply the lender’s Janma Nakshatra so the source prohibition can be enforced; without it, review remains incomplete.",
        "Election chart: Lagna and 7th lords should be harmoniously disposed.",
        "Election chart: Chandra in Vrischika is described as adverse for the lender.",
        "Lineage warning: current Drik Panchang loan-giving practice excludes Wednesday, while this Raman-lineage profile admits it and excludes Tuesday and Friday.",
        "Credit assessment, affordability, documentation, interest and collateral law, concentration risk and qualified financial or legal advice take precedence over timing."
      ],
      "manual_prerequisites": true,
      "avoid_janma_nakshatra": true,
      "avoid_vara_tithi_names": [
        [
          "Shanivaram",
          "Amavasya"
        ]
      ],
      "source_claim": "muhurta.lending_money",
      "related_claims": [
        "muhurta.lending.drkpanchang_divergence"
      ]
    },
    "bhumi_puja": {
      "label": "Bhumi Puja / Foundation laying",
      "skip_on_yoga": [
        "Visha Yoga",
        "Dagdha Yoga"
      ],
      "prefer_vara": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "required_lagna_class": "Sthira",
      "allowed_maasams": [
        "Chaitra",
        "Vaishakha",
        "Shravana",
        "Kartika",
        "Magha"
      ],
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "avoid_vara_paksha": [
        [
          "Somavaram",
          "Krishna"
        ]
      ],
      "allowed_solar_classes": [
        "Sthira",
        "Chara"
      ],
      "allowed_nakshatras": [
        "Rohini",
        "Mrigashira",
        "Chitra",
        "Hasta",
        "Jyeshtha",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Shravana",
        "Swati",
        "Pushya",
        "Anuradha",
        "Ashwini",
        "Shatabhisha",
        "Uttara Bhadrapada",
        "Revati"
      ],
      "prefer_nakshatras": [
        "Rohini",
        "Mrigashira",
        "Chitra",
        "Hasta",
        "Jyeshtha",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Shravana"
      ],
      "allowed_tithi_numbers": [
        1,
        2,
        3,
        5,
        6,
        7,
        10,
        11,
        13,
        15
      ],
      "manual_checks": [
        "Election chart: 8th house from Lagna must be vacant and free of malefic aspect.",
        "Election chart: malefics should occupy 3rd, 6th or 11th; benefics should fortify Kendras and Trikonas.",
        "Site ritual: after Puja, the first foundation stone is placed at the north-eastern corner."
      ],
      "source_claim": "muhurta.bhumi_puja.foundation"
    },
    "well_digging": {
      "label": "Well digging",
      "allowed_nakshatras": [
        "Revati",
        "Uttara Bhadrapada",
        "Hasta",
        "Anuradha",
        "Magha",
        "Shravana",
        "Rohini",
        "Pushya"
      ],
      "manual_checks": [
        "Election chart: Shukra and Chandra should occupy Kendras.",
        "For abundant sweet water, Chandra or Shukra should occupy a Kendra in a full watery Rasi."
      ],
      "allowed_lagnas": [
        "Meena",
        "Karkataka",
        "Makara"
      ],
      "caution_lagna_solar": true,
      "source_claim": "muhurta.well_digging"
    },
    "home_repair": {
      "label": "Home repair / renovation start",
      "prefer_vara": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram"
      ],
      "allowed_varas": [
        "Adivaram",
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram",
        "Shanivaram"
      ],
      "manual_checks": [
        "Scope: commencement of repairs or renovation to an existing home only; painting/whitewashing, dismantling, new construction and post-work re-entry are separate elections.",
        "Weekday-Lagna condition: Friday is especially suitable with Vrishabha or Tula Lagna; Monday is especially suitable with Karka Lagna.",
        "Election chart: Lagna should be occupied by a benefic and Chandra should be in an aquatic Rasi.",
        "Mangala transit: if Chandra is in Krittika, Magha, Pushya, Purva Phalguni, Hasta, Moola or Revati, confirm Mangala is not transiting that same Nakshatra.",
        "Building permits, structural engineering, utility safety and contractor readiness take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.home_repair.commencement"
    },
    "business": {
      "label": "Deploying capital / business investment",
      "required_lagna_class": "Chara",
      "allowed_nakshatras": [
        "Swati",
        "Punarvasu",
        "Chitra",
        "Anuradha",
        "Mrigashira",
        "Revati",
        "Vishakha",
        "Pushya",
        "Shravana",
        "Dhanishtha",
        "Shatabhisha",
        "Ashwini"
      ],
      "manual_checks": [
        "Scope: Dravyaprayoga means putting funds to work or investing capital in an enterprise; founding a company, opening a marketplace, buying inventory and making a loan are separate acts.",
        "Election chart: place benefics in the 5th and 9th houses and leave the 8th house unoccupied.",
        "Commercial viability, diversification, liquidity, contracts, tax and securities law, due diligence and qualified financial or legal advice take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.capital_deployment"
    },
    "job": {
      "label": "Entering employment / starting service",
      "allowed_varas": [
        "Budhavaram",
        "Shukravaram",
        "Adivaram",
        "Guruvaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Pushya",
        "Hasta",
        "Chitra",
        "Anuradha",
        "Mrigashira",
        "Revati"
      ],
      "manual_checks": [
        "Scope: this is the employee-side act of entering service or starting employment; offer acceptance, contract signing, incorporation and hiring staff are separate acts.",
        "Election chart: place a benefic in Lagna and place Surya or Mangala in the 10th or 11th house.",
        "Employer/employee compatibility: compare both birth-Nakshatra Yonis and the friendship between their Janma-Rasi lords.",
        "Employment terms, labour law, compensation, benefits, workplace safety and professional judgment take precedence over timing."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.service_entry"
    },
    "yajna": {
      "label": "Homa offering (Homahuti)",
      "manual_checks": [
        "Ritual scope: this is the source’s Homahuti election, not a universal election for every Yajna. Follow the officiating priest and the specific Kalpa or Sampradaya requirements.",
        "Arrange a qualified officiant, a suitable venue and all required fire-safety precautions."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.homahuti",
      "require_homa_election": true
    },
    "pilgrimage": {
      "label": "Pilgrimage (Tirtha Yatra)",
      "avoid_karana": [
        "Vishti"
      ],
      "prefer_lagna_class": "Chara",
      "prefer_nakshatras": [
        "Mrigashira",
        "Ashwini",
        "Pushya",
        "Punarvasu",
        "Hasta",
        "Anuradha",
        "Shravana",
        "Moola",
        "Dhanishtha",
        "Revati"
      ],
      "avoid_tithi_numbers": [
        14,
        15
      ],
      "manual_checks": [
        "Election chart: place Guru in Lagna or the 9th house, as required by the pilgrimage-specific passage."
      ],
      "source_claim": "muhurta.pilgrimage",
      "skip_on_combust": [
        "Guru"
      ]
    },
    "ceremony": {
      "label": "Shantika / Paushtika rite",
      "skip_on_sankramana": true,
      "allowed_varas": [
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Pushya",
        "Hasta",
        "Uttara Phalguni",
        "Uttara Ashadha",
        "Uttara Bhadrapada",
        "Rohini",
        "Revati",
        "Shravana",
        "Dhanishtha",
        "Shatabhisha",
        "Punarvasu",
        "Swati",
        "Anuradha",
        "Magha"
      ],
      "avoid_tithi_numbers": [
        4,
        8,
        9,
        14,
        15
      ],
      "manual_checks": [
        "Scope: this profile covers Shantika rites that pacify an affliction and Paushtika rites for welfare, including the passage’s examples of auspicious Puja, Purashcharana and Mula-shanti; it is not a universal ceremony election.",
        "Election chart: place Surya in the 10th from Lagna, Chandra in the 4th and Guru in Lagna.",
        "Ideal purity: the commentary prefers avoiding Guru or Shukra combustion and exceptional omens such as Ketu-rise; a practitioner must judge these conditions.",
        "Remedial exception: when an ominous event itself creates the need for Shanti, the commentary says ordinary timing defects need not delay the rite; follow the officiating practitioner."
      ],
      "manual_prerequisites": true,
      "source_claim": "muhurta.shantika_paushtika"
    },
    "court": {
      "label": "Filing a lawsuit / court action",
      "allowed_varas": [
        "Adivaram",
        "Somavaram",
        "Budhavaram",
        "Guruvaram",
        "Shukravaram"
      ],
      "allowed_nakshatras": [
        "Ashwini",
        "Rohini",
        "Mrigashira",
        "Pushya",
        "Uttara Phalguni",
        "Hasta",
        "Chitra",
        "Anuradha",
        "Dhanishtha",
        "Revati"
      ],
      "avoid_tithi_numbers": [
        4,
        6,
        8,
        9,
        12,
        14,
        15
      ],
      "manual_checks": [
        "Scope: this election is for filing or initiating a lawsuit, not a hearing, response, settlement, appeal or prediction of the case outcome.",
        "Tithi cross-reference: Raman says to avoid the usual unfavorable lunar days; the automated list uses his explicit recurring list of Chaturthi, Shashthi, Ashtami, Navami, Dwadashi, Chaturdashi, Pournami and Amavasya from the same edition.",
        "Lagna/Navamsa: automation admits Mesha Lagna. A practitioner may evaluate the source's alternative of a non-Mesha Lagna with Mesha Navamsa.",
        "Election chart: strengthen Lagna with Guru in a Trikona; place no malefic in the 6th; keep the Lagna and 6th lords well separated.",
        "Raman says benefics in Kendras, or benefic aspects from male Rasis, indicate peace between the parties; this is not a promise of legal success.",
        "Legal deadlines, court rules, counsel, evidence and personal safety always take precedence over electional timing."
      ],
      "manual_prerequisites": true,
      "allowed_lagnas": [
        "Mesha"
      ],
      "source_claim": "muhurta.court.filing_lawsuit"
    },
    "surgery": {
      "label": "Surgery / medical procedure",
      "avoid_karana": [
        "Vishti"
      ],
      "allowed_varas": [
        "Mangalavaram",
        "Shanivaram"
      ],
      "allowed_nakshatras": [
        "Ardra",
        "Jyeshtha",
        "Ashlesha",
        "Moola"
      ],
      "manual_checks": [
        "Medical urgency and the treating clinician’s instructions always override Muhurtam; never delay necessary care for an astrological window.",
        "Avoid Chandra in the patient’s natal Rasi and in the Rasi governing the body part being operated on, especially when afflicted by malefics.",
        "Strengthen Mangala and the house governing the body part; leave the 8th house unoccupied and avoid mutual aspects between Mangala and Shani."
      ],
      "source_claim": "muhurta.surgery",
      "allowed_tithi_names": [
        "Shukla Chaturthi",
        "Shukla Navami",
        "Shukla Chaturdashi"
      ]
    },
    "travel": {
      "label": "Travel / journey",
      "avoid_karana": [
        "Vishti"
      ],
      "prefer_lagna_class": "Chara",
      "avoid_nakshatras": [
        "Bharani",
        "Krittika"
      ],
      "prefer_nakshatras": [
        "Mrigashira",
        "Ashwini",
        "Pushya",
        "Punarvasu",
        "Hasta",
        "Anuradha",
        "Shravana",
        "Moola",
        "Dhanishtha",
        "Revati"
      ],
      "manual_checks": [
        "Election chart: fortify Lagna; Guru or Shukra well placed in Lagna is stated to support a successful journey.",
        "For long-distance journeys, prefer waxing Chandra, avoid Mangala in the 8th and avoid malefics in the 7th."
      ],
      "source_claim": "muhurta.travel"
    }
  }
}
